import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";
import { useUserStore } from "@/stores/user-store";

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { accessToken } = useAuthStore();
  const { admin } = useUserStore();
  const isAdminAuth = !!accessToken && !!admin;

  useEffect(() => {
    if (!isAdminAuth && location.pathname !== "/admin/login") {
      navigate("/admin/login", { replace: true });
    }
  }, [isAdminAuth, navigate, location]);

  if (!isAdminAuth) return null;
  return <>{children}</>;
}
